import React, {useState} from "react";
import Dice1 from "../image/tmp-png/dice-1.png";
import Dice2 from "../image/tmp-png/dice-2.png";
import Dice3 from "../image/tmp-png/dice-3.png";
import Dice4 from "../image/tmp-png/dice-4.png";
import Dice5 from "../image/tmp-png/dice-5.png";
import Dice6 from "../image/tmp-png/dice-6.png";
import Dice from "../image/Dice.jpeg";
import diceStyle from "./ManualDice.module.css"
import {useTranslation} from "react-i18next";

function ManualDice(props) {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'manualDice' });
    const [move, setMove] = useState(0)
    const [moveDisabled, setMoveDisabled] = useState(true)
    const [dice1Selected, setDice1Selected] = useState(true)
    const [dice2Selected, setDice2Selected] = useState(true)
    const [dice3Selected, setDice3Selected] = useState(true)
    const [dice4Selected, setDice4Selected] = useState(true)
    const [dice5Selected, setDice5Selected] = useState(true)
    const [dice6Selected, setDice6Selected] = useState(true)

    function setAllDicesState(isSelected) {
        setDice1Selected(isSelected)
        setDice2Selected(isSelected)
        setDice3Selected(isSelected)
        setDice4Selected(isSelected)
        setDice5Selected(isSelected)
        setDice6Selected(isSelected)
    }

    function prepToMove(number) {
        setMove(number)

        setAllDicesState(false)

        switch (number) {
            case 1:
                setDice1Selected(true)
                break
            case 2:
                setDice2Selected(true)
                break
            case 3:
                setDice3Selected(true)
                break
            case 4:
                setDice4Selected(true)
                break
            case 5:
                setDice5Selected(true)
                break
            case 6:
                setDice6Selected(true)
                break
        }
        setMoveDisabled(false)
    }
    function sendMove() {
        props.setDiceValue(move)
        setMove(0)
        setMoveDisabled(true)
        setAllDicesState(true)
    }

    function SetStyle(number, selected) {
        switch (number) {
            case 1:
                this.image = Dice1;
                break;
            case 2:
                this.image = Dice2;
                break;
            case 3:
                this.image = Dice3;
                break;
            case 4:
                this.image = Dice4;
                break;
            case 5:
                this.image = Dice5;
                break;
            case 6:
                this.image = Dice6;
                break;
            default:
                this.image = Dice;
        }

        return Object.assign(
            {
                backgroundImage: "url(" + this.image + ")",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                height: "45px",
                width: "45px",
                margin: "7px",
                justifyContent: "center",
                backgroundPosition: "center",
                opacity: selected ? 1 : 0.3,
                cursor: "pointer"
            }
        )
    }


    return (
        <div className={diceStyle.container}>
            <div className={props.isHorizontal ? diceStyle.diceSelector : diceStyle.diceSelectorVertical}>
                <div style={new SetStyle(1, dice1Selected)} onClick={() => prepToMove(1)}></div>
                <div style={new SetStyle(2, dice2Selected)} onClick={() => prepToMove(2)}></div>
                <div style={new SetStyle(3, dice3Selected)} onClick={() => prepToMove(3)}></div>
                <div style={new SetStyle(4, dice4Selected)} onClick={() => prepToMove(4)}></div>
                <div style={new SetStyle(5, dice5Selected)} onClick={() => prepToMove(5)}></div>
                <div style={new SetStyle(6, dice6Selected)} onClick={() => prepToMove(6)}></div>
            </div>
            <button className={diceStyle.moveButton} type={"button"} onClick={sendMove} disabled={moveDisabled}>
                {t('doMove')}
            </button>
        </div>
    )
}

export default ManualDice;